import type { ClientProfileAddressResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const formatProfileAddress = (
	address?: ClientProfileAddressResponseDTO,
): string => {
	if (!address) {
		return "";
	}

	const streetLine = [address.street, address.descriptiveNumber]
		.filter(Boolean)
		.join(" ");
	const cityLine = [address.city, address.zip].filter(Boolean).join(" ");

	return [streetLine, cityLine].filter(Boolean).join(", ");
};
